import { forwardRef, useId } from 'react'
import type { ChangeEvent, ComponentProps, ElementRef } from 'react'

import type { CSSProps, VariantProps } from 'style'

import { InputStyled } from './input.styled'

const NAME = 'Input'

type InputVariants = VariantProps<typeof InputStyled>
type InputBaseProps = ComponentProps<typeof InputStyled>
type InputCustomProps = { onChangeText?: (val: string) => void }

export type InputProps = InputCustomProps &
  InputBaseProps &
  InputVariants &
  CSSProps

const Input = forwardRef<ElementRef<typeof InputStyled>, InputProps>(
  (props, forwardedRef) => {
    const { id: idProp, valid, onChange, onChangeText, ...rest } = props
    const uid = useId()
    const id = idProp || uid
    const ariaInvalid = valid === false ? 'true' : 'false'

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      event.persist()
      onChange?.(event)
      onChangeText?.(`${event.target.value}`)
    }

    return (
      <InputStyled
        {...rest}
        ref={forwardedRef}
        id={id}
        valid={valid}
        aria-invalid={ariaInvalid}
        onChange={handleChange}
      />
    )
  },
)

Input.defaultProps = {
  type: 'text',
  autoComplete: 'off',
}

Input.displayName = NAME

export default Input
